<template>
  <div class="itemCountBlock">
    <div class="countAction background" @click="sub">
      &minus;
    </div>
    <div class="countNumber">{{ basketitem.count }}</div>
    <div class="countAction background" @click="add">
      &plus;
    </div>
  </div>
</template>

<script>
export default {
  name: "countBlock",
  methods: {
    add() {
      this.$emit("add");
    },
    sub() {
      this.$emit("sub");
    }
  },
  props: {
    basketitem: Object
  }
};
</script>

<style scoped>
.itemCountBlock {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.countAction {
  width: 35px;
  height: 35px;
  border-radius: var(--component_countBlock_countAction_border-radius);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: var(--component_countBlock_countAction_font-family);
  color: var(--component_countBlock_countAction_color);
  font-size: var(--component_countBlock_countAction_font-size);
  background-color: var(--component_countBlock_countAction_background-color);
  padding: var(--component_countBlock_countAction_padding);
}

.countNumber {
  width: 65px;
  color: var(--component_countBlock_countNumber_color);
  font-family: var(--component_countBlock_countNumber_font-family);
  font-size: var(--component_countBlock_countNumber_font-size);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
